import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { AgColor } from '../../Styles/AgColor';
import AgTypography from '../../Styles/AgTypography';
import { CSSProperties, ChangeEventHandler } from 'react';

const CheckBox = (
  {
    id,
    disabled,
    style,
    checked,
    onChange,
    label,
    dataTestId
  }: {
    id?: string,
    disabled?: boolean,
    checked?: boolean,
    style?: CSSProperties | undefined,
    onChange?: ChangeEventHandler | undefined,
    label?: string,
    dataTestId?:string;
  }) => {
  return (
    <FormControlLabel
      data-testid={dataTestId}
      control={
        <Checkbox
          id={id}
          onChange={onChange}
          sx={{
            borderRadius: '2px',
            width: '18px',
            height: '18px',
            color: disabled ? AgColor.grey4 : AgColor.grey5,
            backgroundColor: disabled ? AgColor.grey2 : AgColor.grey0,
            ...style
          }}
          checked={checked}
          disabled={disabled}
        />}
      sx={{
        width: 'fit-content',
        borderRadius: '5px',
        margin: '0',
        ...(!disabled && {
          '&:hover': {
            backgroundColor: AgColor.secondaryLight2,
            color: AgColor.secondaryMain,
            outline: `3px solid ${AgColor.secondaryLight2}`,
            '& .MuiCheckbox-root': {
              color: AgColor.secondaryMain,
              '&:hover': {
                color: AgColor.secondaryMain,
                backgroundColor: AgColor.grey0,
                outline: `3px solid ${AgColor.secondaryLight2}`
              }
            }
          }
        }),
      }}
      style={{
        display: 'flex',
        gap: label ? '8px' : 0,
        padding: '8px, 8px, 8px, 12px'
      }}
      label={
        <AgTypography
          contentStyle={'AP.Paragraph.Large.Regular'}
          style={{ color: disabled ? AgColor.grey5 : AgColor.grey9 }}
        >
          {label}
        </AgTypography>
      }
    />
  );
};

export default CheckBox;